import axios from 'axios';
import qs from 'qs';
import { get } from 'lodash';

const CRULES_LIST_LOAD = 'CRULES_LIST_LOAD';
const CRULES_LIST_SUCCESS = 'CRULES_LIST_SUCCESS';
const CRULES_LIST_FAILED = 'CRULES_LIST_FAILED';
const CRULES_SET_LOADING = 'CRULES_SET_LOADING';
const CRULES_LIST_HIGHTLIGHT = 'CRULES_LIST_HIGHTLIGHT';

const CRULES_FORM_LOAD = 'CRULES_FORM_LOAD';
const CRULES_FORM_SUCCESS = 'CRULES_FORM_SUCCESS';
const CRULES_FORM_FAILED = 'CRULES_FORM_FAILED';

const CRULE_DELETE_LOAD = 'CRULE_DELETE_LOAD';
const CRULE_DELETE_SUCCESS = 'CRULE_DELETE_SUCCESS';
const CRULE_DELETE_FAILED = 'CRULE_DELETE_FAILED';

const CRULE_EDIT_LOAD = 'CRULE_EDIT_LOAD';
const CRULE_EDIT_SUCCESS = 'CRULE_EDIT_SUCCESS';
const CRULE_EDIT_FAILED = 'CRULE_EDIT_FAILED';

const CRULE_VIEW_LOAD = 'CRULE_VIEW_LOAD';
const CRULE_VIEW_SUCCESS = 'CRULE_VIEW_SUCCESS';
const CRULE_VIEW_FAILED = 'CRULE_VIEW_FAILED';

const CRULES_RESET = 'CRULES_RESET';
const CRULES_RESET_FORM = 'CRULES_RESET_FORM';

const initialState = {
  loading: false,
  success: false,
  saved: false,
  failed: false,
  data: [],
  message: null,
  total: 0,
  limit:process.env.REACT_APP_LIST_LIMIT,
  page: null,
  order: '',
  orderMode: 'ASC',
  deleted: false,
  deletedId: null,
  formErrors: {},
  viewData: null,
  viewLoading: false,
  commentThread: false,
  id: null,
    reload: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CRULES_RESET:
      return {
        ...initialState
      };
    case CRULES_RESET_FORM:
      return {
        ...state,
        deleted: false,
        deletedId: null,
        formErrors: {},
        viewData: null,
        viewLoading: false,
        commentThread: false,
        id: null
      };
    case CRULE_DELETE_LOAD:
      return {
        ...state,
        deleted: false,
        deletedId: null,
        viewLoading: false
      };
    case CRULES_LIST_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        viewLoading: false,
        reload: false
      };
    case CRULE_EDIT_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        formErrors: {},
        viewLoading: false
      };
    case CRULE_VIEW_LOAD:
      return {
        ...state,
        loading: true,
        failed: false,
        message: null,
        formErrors: {},
        viewLoading: true
      };
    case CRULES_FORM_LOAD:
      return {
        ...state,
        loading: false,
        failed: false,
        message: null,
        viewLoading: false
      };
    case CRULES_FORM_FAILED:
    case CRULE_EDIT_FAILED:
    case CRULE_DELETE_FAILED:
    case CRULES_LIST_FAILED:
    case CRULE_VIEW_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        saved: false,
        failed: true,
        message: action.message,
        formErrors: action.formErrors || {},
        deleted: true,
        deletedId: null,
        viewLoading: false
      };
      case CRULES_LIST_HIGHTLIGHT:
          return {
              ...state,
              success: true,
              failed: false,
              loading: false,
              reload: true
          };
    case CRULES_LIST_SUCCESS:
      return {
        ...state,
        success: true,
        failed: false,
        data: action.data,
        total: action.total,
        limit: action.limit,
        page: action.page,
        order: action.order,
        orderMode: action.orderMode,
          loading: false
      };
      case CRULE_VIEW_SUCCESS:
        return {
            ...state,
            loading: false,
            success: true,
            failed: false,
            viewData: action.viewData,
            commentThread: action.commentThread || false,
            viewLoading: false
        };
    case CRULES_FORM_SUCCESS:
      return {
        ...state,
        fields: action.fields,
        loading: false,
        success: true,
        failed: false,
        viewLoading: false
      };
    case CRULE_DELETE_SUCCESS:
      return {
        ...state,
        deleted: true,
        deletedId: action.id
      };
    case CRULE_EDIT_SUCCESS:
      return {
        ...state,
        loading: false,
        saved: true,
        failed: false,
        message: null,
        formErrors: {},
        id: action.id,
        viewLoading: false
      };
    case CRULES_SET_LOADING:
      return {
        ...state,
        loading: action.loading,
        viewLoading: false
      };
    default:
      return state;
  }
}

export const reset = () => dispatch => {
  dispatch({
    type: CRULES_RESET
  });
};

export const resetForm = () => dispatch => {
  dispatch({
    type: CRULES_RESET_FORM
  });
};

export const updateCrules = (model,id,data) => dispatch => {
  dispatch({
    type: CRULE_EDIT_LOAD
  });

    let obj = {};
    obj[model] = data;

  return axios.put('/v1/c-rules/'+id, obj).then(
      () => dispatch({
        type: CRULE_EDIT_SUCCESS
      })
  ).catch(error => {
    dispatch({
      type: CRULE_EDIT_FAILED,
      message: get(error, 'response.data.message', null),
      formErrors: get(error, 'response.data.form_errors', {})
    })
  });
};

export const viewCrules = (id) => dispatch => {
    dispatch({
        type: CRULE_VIEW_LOAD
    });
    return axios.get('/v1/c-rules/'+id).then(
        response => dispatch({
            type: CRULE_VIEW_SUCCESS,
            viewData: get(response, 'data.data'),
            commentThread: get(response, 'data.commentThread', false)
        })
    ).catch(error => {
        dispatch({
            type: CRULE_VIEW_FAILED,
            message: get(error, 'response.data.message', null)
        })
    });
};

export const createCrules = (model, data) => dispatch => {
  dispatch({
    type: CRULE_EDIT_LOAD
  });

  let obj = {};
  obj[model] = data;

  return axios.post('/v1/c-rules', obj).then(response => dispatch({
    type: CRULE_EDIT_SUCCESS,
    id: get(response, 'data.data.id', null),
  })).catch(error => {
    dispatch({
      type: CRULE_EDIT_FAILED,
      message: get(error, 'response.data.message', null),
      formErrors: get(error, 'response.data.form_errors', {})
    })
  });
};

export const cruleDelete = (id) => dispatch => {
  dispatch({
    type: CRULE_DELETE_LOAD
  });
  return axios.delete('/v1/c-rules/'+id)
      .then((response) => dispatch({
        type: CRULE_DELETE_SUCCESS,
        id
      })).catch(error => dispatch({
        type: CRULE_DELETE_FAILED,
        message: get(error, 'response.data.message', null)
      }));
};

export const setLoading = (loading) => dispatch => {
  dispatch({
    type: CRULES_SET_LOADING,
    loading
  });
};

export const crulesHightLight = (id) => dispatch => {
    dispatch({
        type: CRULES_LIST_LOAD
    });
    return axios.put('/v1/c-rules/highlight/'+id).then(() => dispatch({
          type: CRULES_LIST_HIGHTLIGHT
    })).catch(error => dispatch({
        type: CRULES_LIST_FAILED,
        message: get(error, 'response.data.message', null)
    }));
};

export const crulesList = (page, keyword, sort, filters, perPage) => dispatch => {
  dispatch({
    type: CRULES_LIST_LOAD
  });

  let params = {
    page,
    keyword,
    sort,
    'per-page': perPage
  };

  params[filters.model] = filters.filters;

  return axios.get(
      '/v1/c-rules',
      {
        params: params,
        paramsSerializer: function(params) {
          return qs.stringify(params, { encode: false });
        }
      },
      {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        }
      }
  ).then(response => {
    let sort = get(response, 'data.sort', null),
        mode = 'ASC';
    if(sort && sort.indexOf('-') !== -1) {
      mode = 'DESC';
      sort = sort.substr(1);
    }
    return dispatch({
      type: CRULES_LIST_SUCCESS,
      data: get(response, 'data.data', null),
      page: get(response, 'data.page', 0),
      limit: get(response, 'data.per-page', 0),
      total: get(response, 'data.total', 0),
      order: sort,
      orderMode: mode
    });
  })
  .catch(error => dispatch({
    type: CRULES_LIST_FAILED,
    message: get(error, 'response.data.message', null)
  }));
};



// WEBPACK FOOTER //
// ./src/redux/modules/crules.js